import { createContext, useContext, useState } from 'react';

import { getUserTimeZone } from '@widget/utils/getUserTimezone';

import type { TimeSlotsType } from '@widget/api/types';
import type { Dispatch, SetStateAction } from 'react';
import type { ReactFCWithChildren } from '@widget/types/ReactFCWithChildren';

export type TimeslotsContextType = {
  timeslots: TimeSlotsType | null;
  setTimeslots: Dispatch<SetStateAction<TimeSlotsType | null>>;
  timeslotsError: string | null;
  setTimeslotsError: Dispatch<SetStateAction<string | null>>;
  timezone: string;
};

const TimeSlotsContext = createContext<TimeslotsContextType | null>(null);

export const TimeslotsProvider: ReactFCWithChildren<any> = ({ children }) => {
  const [timeslots, setTimeslots] = useState<TimeSlotsType | null>(null);
  const [timeslotsError, setTimeslotsError] = useState<string | null>(null);
  const timezone = getUserTimeZone();

  return (
    <TimeSlotsContext.Provider
      value={{ timeslots, setTimeslots, timeslotsError, setTimeslotsError, timezone }}
    >
      {children}
    </TimeSlotsContext.Provider>
  );
};

export const useTimeslots = (): TimeslotsContextType => {
  const timeSlotsContext = useContext(TimeSlotsContext);

  if (timeSlotsContext === null) {
    throw new Error('The useTimeslots hook must be used within the timeSlotsContext provider');
  }

  return timeSlotsContext;
};
